import { Controller } from "@hotwired/stimulus"

// Left-rail shot list for the scene detail modal. Manages which shot's
// detail panel is visible in the right pane. Items and panels are paired
// by `data-shot-id`; clicking an item activates its matching panel.
//
// Defaults to the first item on connect. No persistence — reopening the
// modal after a form submit always resets to Shot 1.
export default class extends Controller {
  static targets = ["item", "panel"]

  connect() {
    const activeItem = this.itemTargets.find(
      (i) => i.getAttribute("aria-current") === "true"
    )
    const target = activeItem || this.itemTargets[0]
    if (target) {
      this.activateId(target.dataset.shotId)
    }
  }

  activate(event) {
    const id = event.currentTarget.dataset.shotId
    this.activateId(id)
  }

  activateId(id) {
    this.itemTargets.forEach((item) => {
      const active = item.dataset.shotId === id
      item.classList.toggle("border-indigo-500", active)
      item.classList.toggle("bg-indigo-50", active)
      item.classList.toggle("ring-1", active)
      item.classList.toggle("ring-indigo-200", active)
      item.classList.toggle("border-gray-200", !active)
      item.classList.toggle("bg-white", !active)
      item.setAttribute("aria-current", active ? "true" : "false")
      item.setAttribute("aria-selected", active ? "true" : "false")
      item.setAttribute("tabindex", active ? "0" : "-1")
    })
    this.panelTargets.forEach((panel) => {
      const active = panel.dataset.shotId === id
      panel.classList.toggle("hidden", !active)
    })
  }
}
